module.exports = __webpack_public_path__ + "img/button-a-patient-01-pierce.232eed17.png";